/* storybook-check-ignore */
import { useState } from 'react';

import { CONSUMER_URL } from 'components/globals';
import { PropertyDetailsType } from 'components/marketplace/property';

import { useObservability } from 'helpers/observability';

export type TourKind = 'selfTour' | 'tourWithAgent';

export const TOUR_ACTION_TEXT: Record<TourKind, string> = {
  selfTour: 'Self-tour now',
  tourWithAgent: 'Tour with agent',
};

export const useTouring = (property: PropertyDetailsType) => {
  const { trackJourneyEvent } = useObservability();
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const tourKind = getTourKind({ property });
  if (!tourKind) {
    return null;
  }

  const handleSelfTour = () => {
    if (tourKind === 'selfTour') {
      trackJourneyEvent('marketplaceProperty', 'tourBookingStart', {
        addressUuid: property.addressToken,
        placement: 'lightbox',
      });
      window.open(`${CONSUMER_URL}/dashboard/buy/tour?id=${property.addressToken}`, '_blank');
    } else {
      setIsDialogOpen(true);
    }
  };

  const closeDialog = () => setIsDialogOpen(false);

  return {
    tourKind,
    handleSelfTour,
    closeDialog,
    isDialogOpen,
  };
};

/** Get the kind of tour the home is enabled for. Returns null if non-tourable. */
const getTourKind = ({ property }: { property: PropertyDetailsType }): TourKind | null => {
  const isSelfTour = property.displayBadge === 'ON_THE_MARKET' || property?.canSelfTour;
  const isTourWithAgent =
    property?.displayBadge === 'TRADITIONAL' || property?.displayBadge === 'UNKNOWN';

  if (isSelfTour) {
    return 'selfTour';
  } else if (isTourWithAgent) {
    return 'tourWithAgent';
  }

  // Fallback to null: Non-tourable
  return null;
};
